import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";

export default function Login() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name}`);
      nav(u.role === "admin" ? "/admin" : "/app");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Login failed.");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: "var(--lavender)" }}>
      <div className="glass rounded-3xl p-10 max-w-md w-full fade-up" data-testid="login-card">
        <h1 className="font-display text-4xl font-bold text-white mb-2">Welcome back</h1>
        <p className="text-white/80 mb-6">The roster's waiting on you.</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="text-white">Email</Label>
            <Input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="bg-white/10 text-white border-white/20 placeholder:text-white/50" />
          </div>
          <div>
            <Label className="text-white">Password</Label>
            <Input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="bg-white/10 text-white border-white/20" />
          </div>
          <Button data-testid="login-submit" type="submit" disabled={loading} className="w-full bg-[#FF1493] hover:bg-[#d1107a] rounded-full py-6 font-bold text-base">{loading ? "Logging in..." : "Log in"}</Button>
        </form>
        <p className="text-white/70 mt-6 text-sm text-center">New here? <Link to="/register" className="neon-pink-text font-bold" data-testid="login-to-register">Get started</Link></p>
      </div>
    </div>
  );
}
